module.exports = __webpack_public_path__ + "stockage.png?1b2467e192f589f3edae6925da379424";